import React from 'react'
import { connect } from 'react-redux'

function TimezonePicker (props) {
  const DEFAULT_TIMEZONE = '0'
  const primaryValue = /^-?\d+$/.test(props.value) ? DEFAULT_TIMEZONE : props.value
  const customValue = props.value === 'custom' ? DEFAULT_TIMEZONE : props.value
  const deviceTimezone = new Date().toString().slice(-14, -6).replace('+0000', '')
  return (
    <div>
      <label>
        {typeof props.label !== 'undefined' ? props.label : 'Timezone'}
        <select value={primaryValue} onChange={props.onChange}>
          <option value='device'>Set by viewing device ({deviceTimezone})</option>
          <option value='default'>User default ({props.user && props.user.timezone})</option>
          <option value='0'>Custom timezone</option>
        </select>
      </label>
      {primaryValue === DEFAULT_TIMEZONE &&
        <label>
          <select value={customValue} onChange={props.onChange}>
            <option value='-43200'>(GMT -12:00) Eniwetok, Kwajalein</option>
            <option value='-39600'>(GMT -11:00) Midway Island, Samoa</option>
            <option value='-36000'>(GMT -10:00) Hawaii</option>
            <option value='-32400'>(GMT -9:00) Alaska</option>
            <option value='-28800'>(GMT -8:00) Pacific Time (US & Canada)</option>
            <option value='-25200'>(GMT -7:00) Mountain Time (US & Canada)</option>
            <option value='-21600'>(GMT -6:00) Central Time (US & Canada), Mexico City</option>
            <option value='-18000'>(GMT -5:00) Eastern Time (US & Canada), Bogota, Lima</option>
            <option value='-14400'>(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz</option>
            <option value='-12600'>(GMT -3:30) Newfoundland</option>
            <option value='-10800'>(GMT -3:00) Brazil, Buenos Aires, Georgetown</option>
            <option value='-7200'>(GMT -2:00) Mid-Atlantic</option>
            <option value='-3600'>(GMT -1:00 hour) Azores, Cape Verde Islands</option>
            <option value='0'>(GMT) Western Europe Time, London, Lisbon, Casablanca</option>
            <option value='3600'>(GMT +1:00 hour) Brussels, Copenhagen, Madrid, Paris</option>
            <option value='7200'>(GMT +2:00) Kaliningrad, South Africa</option>
            <option value='10800'>(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg</option>
            <option value='12600'>(GMT +3:30) Tehran</option>
            <option value='14400'>(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi</option>
            <option value='16200'>(GMT +4:30) Kabul</option>
            <option value='18000'>(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent</option>
            <option value='19800'>(GMT +5:30) Bombay, Calcutta, Madras, New Delhi</option>
            <option value='20700'>(GMT +5:45) Kathmandu</option>
            <option value='21600'>(GMT +6:00) Almaty, Dhaka, Colombo</option>
            <option value='25200'>(GMT +7:00) Bangkok, Hanoi, Jakarta</option>
            <option value='28800'>(GMT +8:00) Beijing, Perth, Singapore, Hong Kong</option>
            <option value='32400'>(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk</option>
            <option value='34200'>(GMT +9:30) Adelaide, Darwin</option>
            <option value='36000'>(GMT +10:00) Eastern Australia, Guam, Vladivostok</option>
            <option value='39600'>(GMT +11:00) Magadan, Solomon Islands, New Caledonia</option>
            <option value='43200'>(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka</option>
          </select>
        </label>
      }
      {props.touched && props.error &&
        <div className={props.errorClass}>
          {props.error}
        </div>
      }
    </div>
  )
}

const mapStateToProps = ({ auth }) => ({
  user: auth.user
})

export default connect(mapStateToProps)(TimezonePicker)



// WEBPACK FOOTER //
// ./src/components/TimezonePicker.js